import React from 'react'
import styles from './Intro.module.css'
import inner from '../Images/iphoneXinner.png'
import { MdOutlineKeyboardArrowLeft } from 'react-icons/md';
import map from '../Images/Map.png'
import token from '../Images/token.png'
import nft from '../Images/nft.png'
import mads from '../Images/mads.png'
import bull from '../Images/bullimage.png'
import kolibri from '../Images/kolibri.png'
import kadd from '../Images/kaddex.png'
import theo from '../Images/theory.png'

const Intro = () => {
    return (
        <>
            <div className={styles.main}>
                <div className={styles.text}>
                    <div className={styles.haeding}>Advertise your crypto project</div>
                    <div className={styles.listation}>
                        <li className={styles.list}>Drop your ad or promotion as an interactive NFT right on the road where it will be picked up automatically by passing drivers</li>
                        <li className={styles.list}> Create a radius around your business and reach every potential customer with a promotion loaded right to their Mapetrics wallet as they approach</li>
                        <li className={styles.list}>No more physical coupons or discount codes</li>
                    </div>
                    <div className={styles.buttonArea}>
                        <button className={styles.start}>Start now</button>
                        <button className={styles.login}>login</button>
                    </div>

                </div>
                <div className={styles.mapArea}>
                    <div className={styles.mobileArea}>
                        <img src={inner} className={styles.innerX} alt="" />
                    </div>
                    <div className={styles.wallCard}>
                        <div className={styles.walletSection}>
                            <MdOutlineKeyboardArrowLeft className={styles.left} />
                            <div className={styles.Wallet}>Wallet</div>
                            <img src={map} alt="" className={styles.map} />

                        </div>
                        <div className={styles.tokensArea}>
                            <div className={styles.token}>
                                <img src={token} alt="" className={styles.tokenImage} />
                                <div className={styles.tokenHeading}>Tokens</div>

                            </div>
                            <div className={styles.nft}>
                                <img src={nft} alt="" className={styles.nftImage} />
                                <div className={styles.tokenHeading}>NFTs</div>
                            </div>
                            <div className={styles.mads}>
                                <div className={styles.madsBack}><img src={mads} className={styles.madsImage} alt="" /></div>
                                <div className={styles.madsHeading}>mAds</div>
                            </div>
                        </div>
                        <div className={styles.lowercard}>
                            <div className={styles.trans}>
                                <div className={styles.transaction}>
                                    <div className={styles.transHeading}>Transactions</div>
                                    <div className={styles.bull}>
                                        <div className={styles.bullarea}>
                                            <img src={bull} className={styles.bullimage} alt="" />
                                            <div className={styles.bullTextArea}>
                                                <div className={styles.bullHeading}>BullCoin</div>
                                                <div className={styles.bulltime}>Today, 17:45 PM</div>
                                            </div>
                                        </div>
                                        <div className={styles.join} style={{ color: "#00A69F" }}>Join our airdrop</div>

                                    </div>
                                    <div className={styles.koli}>
                                        <div className={styles.bullarea}>
                                            <img src={kolibri} className={styles.bullimage} alt="" />
                                            <div className={styles.bullTextArea}>
                                                <div className={styles.bullHeading}>Kolibri USD</div>
                                                <div className={styles.bulltime}>Today, 12:45 PM</div>
                                            </div>
                                        </div>
                                        <div className={styles.join} style={{ color: "#E35039" }}>Free $10 in Kolibri USD</div>

                                    </div>
                                    <div className={styles.koli}>
                                        <div className={styles.bullarea}>
                                            <img src={kadd} className={styles.bullimage} alt="" />
                                            <div className={styles.bullTextArea}>
                                                <div className={styles.bullHeading}>Kaddex</div>
                                                <div className={styles.bulltime}>Yesterday, 11:00 AM</div>
                                            </div>
                                        </div>
                                        <div className={styles.join} style={{ color: "#00A69F" }}>Our ICO launched!</div>

                                    </div>
                                    <div className={styles.koli}>
                                        <div className={styles.bullarea}>
                                            <img src={theo} className={styles.bullimage} alt="" />
                                            <div className={styles.bullTextArea}>
                                                <div className={styles.bullHeading}>THEORY</div>
                                                <div className={styles.bulltime}>May 9, 11:00 AM</div>
                                            </div>
                                        </div>
                                        <div className={styles.join} style={{ color: "#E35039" }}>Join our AMA</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </>
    )
}

export default Intro
